import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import church from '../../assets/images/home/church.png';
import ActionButton from 'components/ui/buttons/action-button';
import Animated from 'components/generals/AnimatedComponent';
import figure from '../../assets/images/home/section_3/3.png';
import plant from '../../assets/images/home/section_3/planta.jpg';
import { FaPlayCircle } from 'react-icons/fa';
import { useAppDispatch } from 'reduxStore/hooks';
import { setDisplayModal, setVideo, setVideoSize } from 'reduxStore/slices/components.slice';
import videoRoots from 'assets/videos/roots.mp4';
export default function Home__section__3() {
    const dispatch = useAppDispatch();
    return (
        <main className="nv__section nv__section--no-margin  nv__hp__section__3">
            <section className="nv__section__container">
                <div className="figure">
                    <Animated animation={'animate__fadeInRight'}>
                        <img src={figure} alt="rows figure green" />
                    </Animated>
                </div>
                <div className="section__block">
                    <Animated animation={'animate__fadeInDown animate__delay-1s'}>
                        <div className="roots__info">
                            <div className="porcent">
                                <span>+</span>
                                <h1>47 mil</h1>
                            </div>
                            <p className="info">
                                Toneladas cosechada con un valor
                                <br /> económico de <strong> 252 millones de pesos</strong>
                            </p>
                        </div>
                    </Animated>
                </div>

                <div className="section__block">
                    <Animated animation={'animate__fadeInRight animate__delay-1s'}>
                        <div
                            className="videoContainer transition"
                            onClick={() => {
                                dispatch(setDisplayModal(true));
                                dispatch(setVideo(videoRoots));
                            }}
                        >
                            <FaPlayCircle />
                        </div>
                    </Animated>
                </div>
            </section>
        </main>
    );
}
